export const BRAND_NAME = "CS Hub";
export const GAMEGUARD_URL =
  "https://client.gameguard.ac/gameguard_setup.exe?v=5";
